import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Flex from 'shopper/components/Flex';
import Text from 'shopper/components/Text';

import Heading from './Heading';

const Wrapper = ({ subtitle, children, ...rest }) => {
  const theme = useTheme();

  return (
    <Box overflow="hidden" {...rest}>
      <Flex
        flexDirection="column"
        borderBottom="1px solid"
        borderColor={theme.app.border}
        pb={4}
      >
        <Heading />
        {subtitle && (
          <Text size="size2" mt={1} px={4}>
            {subtitle}
          </Text>
        )}
      </Flex>
      <Flex flexDirection="column">{children}</Flex>
    </Box>
  );
};

Wrapper.defaultProps = {
  subtitle: null,
};

Wrapper.propTypes = {
  subtitle: PropTypes.string,
};

export default Wrapper;
